<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :setLoading="setLoading"
    :persistenceKey="'label-printing-list'"
    ref="label-printing-list"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { LabelPrintingListService } from "../../_services/api/sales/label-printing-list.service";
import {
  SalesOrderTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/sales/salesorder-tabs";
import { FeatureStorage } from "../../_services/storage";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      gcPopupVisible: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Label Printing",
        ScreenName: "Sales Orders - Label Printing",
        selectedIndex: GetIndexByTabName("Label Printing"),
        tabs: SalesOrderTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SalesOrderLabelPrintingList",
              filter: [
                [
                  ["Status", "=", "A"],
                  "or",
                  ["Status", "=", "L"],
                  "or",
                  ["Status", "=", "H"],
                ],
              ],
              serverPaging: true,
              allowGrouping: false,
              key: "Code",
              select: [
                "Status",
                "StopCredit",
                "CodeComputedString",
                "Code",
                "CustomerCode",
                "CustomerName",
                "BranchCode",
                "BranchDescription",
                "OrderNo",
                "MarketCode",
                "ShipDate",
                "SalesRepresentativeFullName",
                "SalesRepresentativeCode",
                "DateIn",
                "RequiredByDate",
                "CustomerSalesRepresentativeCode",
                "CustomerSalesRepresentativeFullName",
                "DeliveryAddressCompanyName",
                "DeliveryAddressState",
                "FriendlyStatus",
                "FxTotal",
                "CustomerSalesContractName",
                "CustomerSalesContractCode",
                "SalesOrderTypeCode",
                "DistinctProductType",
                "Brand",
                "OrderType",
                "OrderPriority",
                "Carrier",
                "DistinctProductType",
                "DistinctSKUCount",
                "ItemCount",
                "OrderCount",
              ],
            },
            noDataMessage: {
              addNew: {
                class: "hooray",
                title: "No Orders",
                message:
                  "Your work is complete, all orders have been despatched.",
              },
            },
            options: {
              selectionMode: "multiple",
            },
          },
          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            filterOnEnter: true,
            screenName: "Sales Orders - Label Printing",
            customButtons: [
              {
                icon: "more",
                widget: "dxDropDownButton",
                label: "",
                clickAction: {},
                buttonLocation: "right",
                options: {
                  icon: "more",
                  showArrowIcon: false,
                  keyExpr: "menuText",
                  displayExpr: "menuText",
                  dropDownOptions: { width: 150 },
                  items: [
                    {
                      menuText: "Print Label",
                    },
                    {
                      menuText: "Hold Orders",
                    },
                    {
                      menuText: "Activate Orders",
                    },
                  ],
                  onItemClick: this.handleToolbarMenuClick,
                  disabled: !FeatureStorage.checkPermission(
                    "LabelPrinting",
                    "create"
                  ),
                },
              },
            ],
          },
          columns: [
            {
              screenField: "SalesOrder",
              gridDataField: "CodeComputedString",
              dataField: "CodeComputedString",
              calculateSortValue: "Code",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              width: ColumnWidth.SalesOrderCode.width,
              maxWidth: ColumnWidth.SalesOrderCode.minWidth,
              hyperlink: {
                url: "sales-order/review/__ID__",
                target: "_blank",
              },
            },
            {
              screenField: "Code",
              filterLabel: "Sales Order",
              showInColumnChooser: false,
              visible: false,
              type: "Integer",
              filterIndex: 11,
            },
            {
              screenField: "Customer",
              filterIndex: 15,
            },
            {
              screenField: "Branch",
              filterIndex: 16,
              visible: false,
            },
            {
              screenField: "CustPO",
              gridDataField: "OrderNo",
              filterDataField: "OrderNo",
              dataType: "string",
              type: "Text",
              filterIndex: 12,
              maxWidth: ColumnWidth.CustPO.width,
            },
            {
              screenField: "Brand",
              visible: true,
              filterIndex: 1,
              maxWidth: ColumnWidth.Brand.width,
            },
            {
              screenField: "OrderPriority",
              visible: true,
              filterIndex: 2,
              maxWidth: ColumnWidth.OrderPriority.width,
            },
            {
              screenField: "StarShipitCarrier",
              visible: false,
              filterIndex: 3,
              maxWidth: ColumnWidth.Carrier.width,
            },
            {
              screenField: "State",
              dataField: "DeliveryAddressState",
              gridDataField: "DeliveryAddressState",
              filterDataField: "DeliveryAddressState",
              dataSourceConfig: {
                endpoint: "api/SalesOrderState",
                sort: {
                  selector: "State",
                  asc: true,
                },
              },
              filterIndex: 13,
              visible: false,
              maxWidth: ColumnWidth.State.width,
            },
            {
              screenField: "Market",
              dataField: "MarketCode",
              filterDataField: "MarketCode",
              visible: false,
              maxWidth: ColumnWidth.Market.width,
            },
            {
              screenField: "ShipDate",
              gridLabel: "Ship Date",
              visible: false,
              filterIndex: 18,
            },
            {
              screenField: "OrderRep",
              visible: false,
              gridDataField: "SalesRepresentativeFullName",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "SalesRepresentativeFullName",
                  },
                ],
                secondary: [
                  {
                    dataField: "SalesRepresentativeCode",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "SalesRepresentativeCode",
                  label: "Order Rep Code",
                },
                {
                  dataField: "SalesRepresentativeFullName",
                  label: "Order Rep Full Name",
                  allowSearch: false,
                },
              ],
              filterDataField: "SalesRepresentativeCode",
            },
            {
              screenField: "DateIn",
              gridLabel: "Date In",
              filterLabel: "Date In",
              visible: false,
              filterIndex: 17,
            },
            {
              screenField: "RequiredByDate",
              gridLabel: "Reqd Date",
              filterLabel: "Reqd Date",
              filterDataField: "RequiredByDate",
              visible: false,
              filterIndex: 19,
            },
            {
              screenField: "CustomerRep",
              visible: false,
            },
            {
              screenField: "DeliveryCompany",
              visible: false,
              gridLabel: "Delivery Company",
            },
            {
              screenField: "OrderStatus",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 14,
              dataSourceConfig: {
                data: ["Active", "Locked", "On Hold"],
              },
            },

            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: `Print Label`,
                      data: data,
                      clickAction: this.printLabel,
                      visible: FeatureStorage.checkPermission(
                        "SalesOrder",
                        "create"
                      ),
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
            },
            {
              screenField: "Contract",
              label: {
                text: "Contract",
              },
              gridDataField: "CustomerSalesContractName",
              visible: false,
              showInColumnChooser: false,
              filterDataField: "CustomerSalesContractCode",
              cellTemplate: "",
              cellTemplateRecord: "",
            },
            {
              screenField: "WebOrderType",
              filterDataField: "OrderType",
              filterLabel: "Order Type",
              cellTemplate: "",
              cellTemplateRecord: "",
              filterIndex: 6,
              visible: false,
            },
            {
              screenField: "Product",
              visible: false,
              filterLabel: "Product",
              filterIndex: 7,
              filterOperator: "contains",
              gridDataField: "ItemCodeList",
              filterDataField: "ItemCodeList",
              dataSourceConfig: {
                endpoint: "api/Product",
                sort: {
                  selector: "Description1",
                  asc: true,
                },
              },
            },
            {
              screenField: "ProductType",
              filterDataField: "DistinctProductType",
              filterLabel: "Product Type",
              filterOperator: "contains",
              cellTemplate: "",
              cellTemplateRecord: "",
              filterIndex: 5,
              visible: false,
            },
            {
              screenField: "ItemCount",
              filterIndex: 8,
              alignment: "right",
              maxWidth: ColumnWidth.ItemCount.width,
              width: ColumnWidth.ItemCount.width,
              visible: false,
              intOperators: true,
              type: "Integer",
            },
            {
              screenField: "SkuCount",
              dataField: "DistinctSKUCount",
              filterDataField: "DistinctSKUCount",
              maxWidth: ColumnWidth.ItemCount.width,
              width: ColumnWidth.ItemCount.width,
              alignment: "right",
              filterIndex: 9,
              visible: false,
              intOperators: true,
              type: "Integer",
            },
            {
              screenField: "OrderCount",
              filterIndex: 10,
              alignment: "right",
              maxWidth: ColumnWidth.ItemCount.width,
              width: ColumnWidth.ItemCount.width,
              visible: false,
              intOperators: true,
              type: "Integer",
            },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    async handleToolbarMenuClick(e) {
      let selectedRows =
        this.$refs["label-printing-list"].$refs[
          "transactionListGrid"
        ].selectedRowData();

      if (selectedRows.length > 0) {
        if (e.itemData.menuText == "Print Label") {
          await this.printLabels(selectedRows);
        } else if (e.itemData.menuText == "Hold Orders") {
          await this.holdOrders(selectedRows);
        } else if (e.itemData.menuText == "Activate Orders") {
          await this.activateOrders(selectedRows);
        }
      } else {
        this.$alert("At least one line should be selected.", "Action Required");
      }
    },
    async holdOrders(selectedRows) {
      var payload = {
        SalesOrderCodes: selectedRows.map((x) => x.Code),
      };

      await LabelPrintingListService.holdOrders(payload)
        .then(() => {
          this.$notify(
            "The selected sales orders have been put On Hold",
            "success"
          );

          this.$refs["label-printing-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
          this.$notify("Orders could not be held.", "error");
        });
    },
    async activateOrders(selectedRows) {
      var payload = {
        SalesOrderCodes: selectedRows.map((x) => x.Code),
      };

      await LabelPrintingListService.activateOrders(payload)
        .then(() => {
          this.$notify(
            "The selected sales orders have been Activated",
            "success"
          );

          this.$refs["label-printing-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
          this.$notify("Orders could not be activated.", "error");
        });
    },
    async printLabels(selectedRows) {
      var payload = {
        SalesOrderCodes: selectedRows.map((x) => x.Code),
      };

      await LabelPrintingListService.printLabel(payload)
        .then(() => {
          this.$notify("Label printing has been completed.", "success");

          this.$refs["label-printing-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
          this.$notify("Label printing could not be completed.", "error");
        });
    },
    async printLabel(data) {
      let payload = {
        SalesOrderCodes: [data.Code],
      };
      await LabelPrintingListService.printLabel(payload)
        .then(() => {
          this.$notify(`Label printing has been completed.`, "success");

          this.$refs["label-printing-list"].$refs[
            "transactionListGrid"
          ].gridRepaint();
        })
        .catch((err) => {
          this.serverError = {
            err: err,
            msg: "Update Failed.",
            time: new Date().getTime(),
          };
          this.$notify(
            `Label printing for SO #${data.Code} could not be completed.`,
            "error"
          );
        });
    },

    rowClickCallBack() {
      return false;
    },
  },
  async created() {
    this.setLoading = true;
  },
};
</script>

<style lang="scss"></style>
